import { motion } from "framer-motion";
import React from "react";
import styled from "styled-components";

const Loading = () => {
  // Text animation variants
  const titleVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1,
      },
    },
    exit: {
      opacity: 0,
      transition: {
        staggerChildren: 0.05,
        staggerDirection: -1,
      },
    },
  };

  const letterVariants = {
    hidden: { 
      opacity: 0,
      y: 20 
    },
    visible: { 
      opacity: 1,
      y: 0,
      transition: {
        type: "spring",
        damping: 12,
        stiffness: 100,
      }
    },
    exit: {
      opacity: 0,
      y: -20,
      transition: {
        duration: 0.2,
      }
    },
  };

  // Loading bar animation
  const loadingBarVariants = {
    hidden: { 
      scaleX: 0,
      originX: 0,
    },
    visible: { 
      scaleX: 1,
      transition: {
        duration: 1.8,
        ease: "easeInOut",
      }
    },
    exit: {
      scaleX: 1.1,
      opacity: 0,
      transition: {
        duration: 0.4,
      }
    }
  };

  // Text content
  const title = "SHOUMIK";

  return (
    <StyledLoading
      initial="hidden"
      animate="visible"
      exit="exit"
      transition={{ duration: 0.6 }}
    >
      <div className="content">
        <motion.div className="title" variants={titleVariants}>
          {title.split("").map((letter, index) => (
            <motion.span key={index} variants={letterVariants}>
              {letter}
            </motion.span>
          ))}
        </motion.div>
        
        <div className="loading-bar-container">
          <motion.div 
            className="loading-bar"
            variants={loadingBarVariants}
          />
        </div>
        
        <motion.p 
          className="subtitle"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.8, duration: 0.8 }}
          exit={{ opacity: 0, transition: { duration: 0.3 } }}
        >
          Developer & Designer
        </motion.p>
      </div>
      
      <motion.div
        className="footer"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 1, duration: 0.8 }}
        exit={{ opacity: 0, transition: { duration: 0.3 } }}
      >
        Made with <span>&hearts;</span> by Shoumik
      </motion.div>
    </StyledLoading>
  );
};

const StyledLoading = styled(motion.div)`
  height: 100vh;
  width: 100vw;
  overflow: hidden;
  position: absolute;
  top: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--primary-background);
  color: var(--primary-text);
  z-index: 6;
  
  .content {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
  
  .title {
    display: flex;
    font-size: 3.5rem;
    font-weight: 800;
    letter-spacing: 0.15em;
    color: var(--primary-text);
    margin-bottom: 1rem;
  }
  
  .loading-bar-container {
    width: 200px;
    height: 3px;
    background-color: rgba(var(--primary-text-rgb, 0, 0, 0), 0.1);
    margin: 1.5rem 0;
    border-radius: 2px;
    overflow: hidden;
  }
  
  .loading-bar {
    height: 100%;
    background: linear-gradient(
      90deg,
      var(--vibrant, #4a5bef) 0%,
      var(--accent-color, #61DAFB) 100%
    );
    border-radius: 2px;
  }
  
  .subtitle {
    font-size: 1rem;
    font-weight: 400;
    letter-spacing: 0.2em;
    text-transform: uppercase;
    color: var(--secondary-text);
  }
  
  .footer {
    font-size: 1rem;
    position: absolute;
    bottom: 10%;
    font-weight: 400;
    color: var(--secondary-text);
    opacity: 0.8;
    
    span {
      color: red;
      margin: 0 0.25rem;
    }
  }
  
  @media (max-width: 768px) {
    .title {
      font-size: 2.5rem;
    }
    
    .loading-bar-container {
      width: 160px;
    }
    
    .subtitle {
      font-size: 0.9rem;
    }
    
    .footer {
      font-size: 0.9rem;
    }
  }
`;

export default Loading;
